export interface DraftVariations {
  subject: string;
  body: string;
  id: number;
  color: string;
  focus: string;
  label: string;
  generationMetadata?: {
    templateId?: string;
    templateLabel?: string;
  };
  title?: string;
  description?: string;
  tags?: string[];
}

export interface GenerateCampaignResponse {
  status?: string;
  drafts?: DraftVariations[];
  preferred_variation?: number;
  research?: string;
}

export enum ContentFocus {
  ABOUT_PRODUCT = "about_product",
  GENERAL_POST = "general_post",
}

export enum ContentMode {
  SEO_ARTICLE = "seo_article",
  SOCIAL = "social",
  BLOG_PROMOTION = "blog_promotion",
  EMAIL = "email  ",
}

export enum CreatorStudioMode {
  SOCIAL_POST = "social_post",
  BLOG_PROMOTION = "blog_promotion",
}
